import fetch from "../fetch";
import pickBy from "lodash/pickBy";

export default ({ params = {} } = {}) =>
  fetch({ path: "/clo/deals", params: pickBy(params) });
